import React from 'react';
import styled from 'styled-components';
import { ResultPage } from './../../components/ResultPage';

const Wrapper = styled.div`
	margin: 0 auto;
	position: absolute;
	left: -10000px;
	top: -10000px;
	width: 1200px;
	background-color: white;
	svg {
		width: 100%!Important;
	}
	#result {
		margin-right: 0px!Important;
		span {
			font-size: 1em;
			font-weight: bold;
		}
	}
`;

const ContentWrapper = styled.div`
	width: 75%;
	padding: 1em;
`;

const Header = styled.div`
`;

const Title = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Name = styled.span`
	color: #009cdc!Important;
`;

const SmallText = styled.p`
	font-size: .7em;
	line-height: 1.2em;
`;

const Logo = styled.div`
	text-align: right;
	background-color: white;
	img {
		width: 250px;
	}
`;

export const ResultLayout = (props) => {
	const { data: { submitForm: { yourName } = {} } = {}, isNoPrivacy } = props;
	const title = !isNoPrivacy ? 'Absenteeism calculator report for ' : 'Absenteeism calculator report';
	return (
		<Wrapper>
			<ContentWrapper id='toPrint'>
				<Header>
					<Title>
						<h1>{title}{!isNoPrivacy && <Name>{yourName}</Name>}</h1>
						<Logo><img alt='' src='images/logo019x2.png' /></Logo>
					</Title>
					<h2 style={{ fontSize: 20 }}>Please find below your personalised report, detailing the impact of absenteeism on your business. Please remember that these results are only a guide and are not guaranteed.</h2>
				</Header>
				<ResultPage {...props} />
				<img alt='' width='100%' style={{ marginTop: '1em' }} src='images/diagram.jpg' />
				<SmallText>* Please note that your call will be recorded for our mutual security and also for training and quality purposes. Lines are open 8am – 5pm, Monday to Friday (except Bank Holidays).
					Benenden is a trading name of The Benenden Healthcare Society Limited and its subsidiaries. Healthcare for Business is provided by The Benenden Healthcare Society Limited which is an incorporated Friendly Society, registered under the Friendly Societies Act 1992, registered number 480F. The Society’s contractual business (the provision of tuberculosis bene t) is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, FRN 205351. The remainder of the Society’s business is undertaken on a discretionary basis. Health Cash Plan for Business is sold by Benenden Wellbeing Limited which is an insurance intermediary authorised and regulated by the Financial Conduct Authority, FRN 593286. Registered O ce: Holgate Park Drive, YO26 4GG registered in England and Wales (Company No. 8271017). Health Cash Plan for Business is issued by BHSF Limited. BHSF Limited which is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and Prudential Regulation Authority. Registered in England and Wales (company number 35500). Registered o ce: 2 Darnley Road, Birmingham B16 8TE.
					Health Assessments for Business are o ered by Benenden Wellbeing Limited. Full details on all products are available by contacting Benenden on 0800 414 8179 or by emailing salessupport@benenden.co.uk.</SmallText>
			</ContentWrapper>
		</Wrapper>
	);
};

export default ResultLayout;



// WEBPACK FOOTER //
// ./src/html/layouts/ResultLayout/index.js